import React, { useState, useEffect, useContext } from 'react';
import styles from './PocetnaOglasnaPloca.module.css';
import { BASE_URL_OGLASI } from '../util/constants';
import { Link } from 'react-router-dom';
import { parseTimestamp } from '../util/TimestampParser';
import { ThemeContext } from '../contexts/ThemeContext';

const PocetnaOglasnaPloca = ({id, setGotOglasData, naslov}) => {
  const [ oglasi, setOglasi ] = useState([]);
  const { dark } = useContext(ThemeContext);

  useEffect(() => {
    fetch(BASE_URL_OGLASI + id)
      .then(response => response.json())
      .then(data => {
        setOglasi(data);
        if (data.length > 0){
          setGotOglasData(true);
        }
      })
      .catch(function (err) {
        console.log('Fetch Error :', err);
      });
  }, [id, setGotOglasData]);

  return (
    <>
      {oglasi === undefined || oglasi.length === 0 ? (
        null
      ) : (
          <>
            <div
              className={dark ? styles.oglasnaPlocaHeadingDark : styles.oglasnaPlocaHeadingLight}>
              <Link to={'/oglasi/godina/' + id}>{naslov}</Link>
            </div>
            {oglasi.map(oglas => {
              return (
                <Link
                  to={'/oglasi/godina/' + id + '/oglas/' + oglas.id} key={oglas.id}>
                  <div className={dark ? styles.oglasDark : styles.oglasLight}>
                    <div className={dark ? styles.oglasHeadingDark : styles.oglasHeadingLight}>
                      {oglas.naslov}
                      {oglas.uvod != null && oglas.uvod.trim() !== "" ? " - " + oglas.uvod : ""}
                    </div>
                    <div className={dark ? styles.oglasTimestampDark : styles.oglasTimestampLight}>
                      {parseTimestamp(oglas.vrijemeKreiranja).join(' ')}
                    </div>
                  </div>
                </Link>
              );
            })}
          </>
        )}
    </>
  );
}

export default PocetnaOglasnaPloca;